import { Task } from "@/types/Task";
import { DataRoomSmallFile } from "./DataRoomSmallFile";

export enum RedFlagStatus {
  CREATED = "CREATED",
  ASSIGNED = "ASSIGNED",
  FIXED = "FIXED",
  DISMISSED = "DISMISSED",
}

export type DataRoomRedFlag = {
  name: string;
  status: RedFlagStatus;
  updatedAt: string;
  createdAt: string;
  externalId: string;
  task: Task;
  file: DataRoomSmallFile;
};
